import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import Alert from 'flarum/common/components/Alert';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class SuggestionModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "category", void 0);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "suggestions", []);
    _defineProperty(this, "loadingSuggestions", true);
    _defineProperty(this, "cancellingId", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.category = this.attrs.category;
    this.name = Stream('');
    this.loadSuggestions();
  }
  className() {
    return 'HFAwardsModal HFAwardsSuggestionModal Modal--small';
  }
  title() {
    return app.translator.trans('huseyinfiliz-awards.forum.other.suggest');
  }
  async loadSuggestions() {
    this.loadingSuggestions = true;
    m.redraw();
    try {
      const response = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/award-user-suggestions',
        params: {
          'filter[category]': this.category.id()
        }
      });
      this.suggestions = (response.data || []).map(item => {
        return app.store.pushObject(item);
      });
    } catch (error) {
      console.error('Failed to load suggestions:', error);
      this.suggestions = [];
    }
    this.loadingSuggestions = false;
    m.redraw();
  }
  getRemainingSlots() {
    const userVoteCount = (this.category.userVoteIds() || []).length;
    const votesPerCategory = parseInt(app.forum.attribute('awardsVotesPerCategory') || '1', 10);
    if (votesPerCategory === 0) return Infinity;

    // Use the locally loaded suggestions list for accurate pending count
    const pendingCount = this.suggestions.filter(s => s.isPending()).length;
    return Math.max(0, votesPerCategory - userVoteCount - pendingCount);
  }
  updateCategoryPendingCount() {
    // Update the category model in the store with the new pending count
    const pendingCount = this.suggestions.filter(s => s.isPending()).length;

    // Update the category's data in the store
    this.category.pushData({
      attributes: {
        userPendingSuggestionsCount: pendingCount
      }
    });
  }
  content() {
    // Show loading state while suggestions are being fetched
    if (this.loadingSuggestions) {
      return m("div", {
        className: "Modal-body"
      }, m(LoadingIndicator, null));
    }
    const remainingSlots = this.getRemainingSlots();
    const isUnlimited = parseInt(app.forum.attribute('awardsVotesPerCategory') || '1', 10) === 0;
    const canSubmit = isUnlimited || remainingSlots > 0;
    return m("div", {
      className: "Modal-body"
    }, canSubmit ? m("div", {
      className: "SuggestionModal-form"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('huseyinfiliz-awards.forum.other.placeholder')), m("input", {
      className: "FormControl",
      bidi: this.name,
      required: true
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary",
      type: "submit",
      loading: this.loading,
      disabled: !this.name()
    }, app.translator.trans('huseyinfiliz-awards.forum.other.submit')), !isUnlimited && m("span", {
      className: "SuggestionModal-remaining"
    }, app.translator.trans('huseyinfiliz-awards.forum.other.remaining', {
      count: remainingSlots
    })))) : m("div", {
      className: "Form-group"
    }, m(Alert, {
      type: "warning",
      dismissible: false
    }, app.translator.trans('huseyinfiliz-awards.forum.other.no_remaining'))), m("div", {
      className: "SuggestionModal-list"
    }, m("h4", {
      className: "SuggestionModal-listTitle"
    }, app.translator.trans('huseyinfiliz-awards.forum.other.my_suggestions')), this.suggestions.length === 0 ? m("p", {
      className: "SuggestionModal-empty"
    }, app.translator.trans('huseyinfiliz-awards.forum.other.no_suggestions')) : m("ul", {
      className: "SuggestionModal-suggestions"
    }, this.suggestions.map(suggestion => this.renderSuggestionItem(suggestion)))));
  }
  renderSuggestionItem(suggestion) {
    const status = suggestion.status();
    const statusLabels = {
      pending: app.translator.trans('huseyinfiliz-awards.forum.other.status_pending'),
      approved: app.translator.trans('huseyinfiliz-awards.forum.other.status_approved'),
      rejected: app.translator.trans('huseyinfiliz-awards.forum.other.status_rejected'),
      merged: app.translator.trans('huseyinfiliz-awards.forum.other.status_merged')
    };
    return m("li", {
      className: "SuggestionModal-item",
      key: suggestion.id()
    }, m("span", {
      className: "SuggestionModal-itemName"
    }, suggestion.name()), m("span", {
      className: `SuggestionModal-itemStatus SuggestionModal-itemStatus--${status}`
    }, statusLabels[status] || status), suggestion.isPending() && m(Button, {
      className: "Button Button--icon Button--link SuggestionModal-itemCancel",
      icon: "fas fa-times",
      onclick: () => this.cancelSuggestion(suggestion),
      loading: this.cancellingId === suggestion.id(),
      title: app.translator.trans('huseyinfiliz-awards.forum.other.cancel')
    }));
  }
  async cancelSuggestion(suggestion) {
    if (!confirm(app.translator.trans('huseyinfiliz-awards.forum.other.cancel_confirm'))) {
      return;
    }
    this.cancellingId = suggestion.id();
    m.redraw();
    try {
      await app.request({
        method: 'DELETE',
        url: app.forum.attribute('apiUrl') + '/award-other-suggestions/' + suggestion.id()
      });

      // Remove from local list
      this.suggestions = this.suggestions.filter(s => s.id() !== suggestion.id());

      // Update the category model in the store so OtherCard reflects the change
      this.updateCategoryPendingCount();
    } catch (error) {
      console.error('Failed to cancel suggestion:', error);
    }
    this.cancellingId = null;
    m.redraw();
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/award-other-suggestions',
      body: {
        data: {
          attributes: {
            categoryId: this.category.id(),
            name: this.name()
          }
        }
      },
      errorHandler: this.onerror.bind(this)
    }).then(response => {
      // Add to local list
      const newSuggestion = app.store.pushObject(response.data);
      this.suggestions.unshift(newSuggestion);
      this.name('');
      this.loading = false;

      // Update the category model in the store
      this.updateCategoryPendingCount();
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('huseyinfiliz-awards', 'forum/components/SuggestionModal', SuggestionModal);